import Vue from 'vue';

Vue.component('dashboard-index', () =>
    import(/* webpackChunkName: 'dashboard-index' */ './dashboard-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/dashboard/index.js